import { surveyAnalyzeModule } from '@/store/modules/frames/survey-analyze.module';
import { EChartService } from './echart.service';
import { GrowthMindsetMapData } from '@/models/school-group/school-group-trend-analysis';
import { SurveyAnalysisCountAndPercent, SurveyAnalysisTabelMapping } from '@/models/jgrow/survey-analysis-tabel-mapping';

export class SurveyAnalysisCircleEchartService extends EChartService {
  self: any;
  val: number;
  data: GrowthMindsetMapData[];
  competencyID: number;

  constructor() {
    super();
    this.data = [];
    this.series = [];
    this.labels = [];
  }

  /**
   * 意識の変容の円グラフ
   */
  get subTableColmuns(): any[] {
    return [];
  }
  get subTableData(): any[] {
    return [];
  }

  setCompetencyID(competencyID: number) {
    this.competencyID = competencyID;
  }

  async addSeries(competencyID: number): Promise<void> {
    this.setCompetencyID(competencyID);
    if (!this.series.length) this.setSeries(await this.makeCircleGraphSeries());
  }

  async makeCircleGraphSeries(): Promise<any[]> {
    const surveyCountMap = await surveyAnalyzeModule.getCompetencyAnswerTabels();
    const series: any[] = new Array();

    surveyCountMap.forEach((value: SurveyAnalysisTabelMapping, key: number) => {
      series.push({
        name: '円グラフ',
        competencyID: key,
        type: 'pie',
        stack: 'positive',
        radius: '80%',
        center: ['50%', '50%'],
        itemStyle: {
          normal: {
            label: {
              show: true,
              position: 'inside',
              formatter: function(params: any) {
                if (params.value == 0) return '';
                return params.name + ': ' + params.value + '%';
              },
            },
          },
        },
        labelLayout: { hideOverlap: true },
        data: [
          ...value.pointList.map((p: SurveyAnalysisCountAndPercent, i) => {
            return { value: p.percent, name: String(i + 1) };
          }),
        ],
      });
    });
    return series;
  }

  get options() {
    const lavels: string[] = [
      '1：全く意欲が高まらない',
      '2：意欲が高まらない',
      '3：どちらかと言えば意欲が高まらない',
      '4：どちらとも言えない',
      '5：どちらかと言えば意欲が高まった',
      '6：意欲が高まった',
      '7：非常に意欲が高まった',
    ];

    return {
      title: { text: surveyAnalyzeModule.competencyNameMap.get(this.competencyID), subtext: '', show: true, left: 'left', textStyle: { color: '#515a6e', fontSize: 20, fontFamily: 'Noto Sans JP' } },
      legend: {
        bottom: '2%',
        show: true,
        // 1から7までの文字列リストを生成
        data: [...Array(7).keys()].map(i => String(i + 1)),
      },
      grid: {
        bottom: '0%',
      },
      formatter: function(params: any) {
        return params;
      },
      axisLabel: {
        formatter: '{value}',
        rotate: 25,
      },
      tooltip: {
        formatter: function(param: any) {
          const line1: string = ` 7段階中${lavels[Number(param.data.name) - 1]}`;
          const line2: string = `割合：${param.data.value} ％`;
          return [line1, line2].join('<br/>');
        },
      },
      calculable: true,
      series: [this.series.find((s: any) => s.competencyID === this.competencyID)],
    };
  }
}
